import React from 'react';
import SectionHeader from '../components/SectionHeader';
import Reveal from '../components/Reveal';
import { safariZones } from '../mock';

export default function Safari() {
  return (
    <div>
      <div className="relative h-[46vh] min-h-[340px] bg-cover bg-center" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1751931817996-368c9ee352ee?crop=entropy&cs=srgb&fm=jpg&q=85)` }}>
        <div className="absolute inset-0 bg-[#1a1108]/70" />
        <div className="container-x relative z-10 h-full flex flex-col justify-center">
          <span className="eyebrow text-[#f0b040]">Explore</span>
          <h1 className="font-display text-5xl md:text-6xl text-[#fff8ec] font-bold">The Safari Park</h1>
        </div>
      </div>

      <section className="section">
        <div className="container-x">
          <Reveal>
            <SectionHeader center eyebrow="Zones" title="Four Distinct Wildlife Zones" subtitle="Every zone is thoughtfully designed to replicate the animals’ natural habitat." />
          </Reveal>

          <div className="space-y-16 mt-10">
            {safariZones.map((z, i) => (
              <Reveal key={z.title} delay={i * 100}>
                <div className={`grid md:grid-cols-2 gap-10 items-center ${i % 2 ? 'md:[&>*:first-child]:order-2' : ''}`}>
                  <div className="overflow-hidden rounded-lg shadow-xl">
                    <img src={z.img} alt={z.title} className="w-full h-96 object-cover img-zoom" />
                  </div>
                  <div>
                    <span className="eyebrow">Zone 0{i + 1}</span>
                    <h3 className="font-display text-4xl text-[#2b1d0e] mt-2 mb-3">{z.title}</h3>
                    <div className="h-divider mb-4" />
                    <p className="text-[#5c4020] leading-relaxed text-lg">{z.desc}</p>
                    <ul className="mt-5 space-y-2 text-sm text-[#3d2a12]">
                      <li>• Guided by expert naturalists</li>
                      <li>• Duration: ~45 minutes</li>
                      <li>• Eco-friendly safari vehicles</li>
                    </ul>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
